import React, { FC, useEffect, useMemo } from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '@const/index';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './sidebar';
import Button from '@components/common/button';
import { Icon } from '@components/icons';
import { useGlobalContext } from '@hooks/context/useGlobalContext';
import classNames from 'classnames/bind';
import ActivityServiceProvider from '../../service_providers/activity_provider';
import { useUserContext } from '@hooks/context/useUserContext';
import { getFirstLetter } from '@utils/index';

interface IProps {
    className?: string;
}

const cx = classNames.bind(styles);
const GlobalProvider: FC<IProps> = () => {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const { navigateButton } = useGlobalContext();
    const { user } = useUserContext();

    useEffect(() => {
        if (
            localStorage.getItem('language') &&
            supportedLanguages.includes(localStorage.getItem('language') || 'en')
        ) {
            i18n.changeLanguage(localStorage.getItem('language') || 'en');
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const contentStyles = useMemo(
        () => cx([styles.content, { isBack: !!navigateButton.label }]),
        [navigateButton]
    );

    return (
        <ActivityServiceProvider>
            <div className={styles.wrapper}>
                <Sidebar />
                <div className={contentStyles}>
                    <div className={styles.user_wrapper}>
                        <div className={styles.avatar}>
                            <p>
                                {getFirstLetter(user?.profile?.first_name)}
                                {getFirstLetter(user?.profile?.last_name)}
                            </p>
                        </div>
                        <div className={styles.name}>
                            {user?.profile?.first_name} {user?.profile?.last_name}
                        </div>
                    </div>
                    {navigateButton.label && (
                        <Button
                            className={styles.back_button}
                            onClick={() => navigate(navigateButton.route)}>
                            {' '}
                            <Icon name="arrow_left" /> {navigateButton.label}
                        </Button>
                    )}
                    <Outlet />
                </div>
            </div>
        </ActivityServiceProvider>
    );
};

export default GlobalProvider;
